// extracted by mini-css-extract-plugin
export default {"container":"EditForm_container__-+34w","header":"EditForm_header__-dWTH","footer":"EditForm_footer__jGH+E","body":"EditForm_body__vBl98","button":"EditForm_button__KOpZ0"};